/**
 * Navigate to a state-creating route by submitting a same-origin form POST.
 *
 * The Checkout routes create Stripe state (a Checkout Session, the user's
 * single attempt slot), so they are POSTs that prove same-origin — see
 * `src/routes/requireSameOrigin.js`. A GET carries no Origin header and can be
 * driven by any cross-site link, redirect or link prefetch. Their parameters
 * stay in the URL's query string, so the submitted form is empty and the
 * response is still an ordinary redirect the browser follows.
 *
 * @param url same-origin route to POST to, query string included
 */
export const postNavigate = (url: string) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = url;
  document.body.appendChild(form);
  form.submit();
};

export default postNavigate;
